import API_BASE_URL from './urlHelper';
import { fetchWithAuth } from './authToken';

function toQuery(params = {}) {
  const qp = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== '') {
      // Convertir booleanos a 1 o 0 para que Laravel los acepte
      if (typeof v === 'boolean') {
        qp.set(k, v ? '1' : '0');
      } else {
        qp.set(k, v);
      }
    }
  });
  return qp.toString();
}

/**
 * GET /api/admin/renta-dashboard/asesores
 * Obtiene la lista de asesores para el filtro
 */
export async function getAsesores() {
  const url = `${API_BASE_URL}/api/admin/asesores`;

  const res = await fetchWithAuth(url, {
    method: 'GET',
    headers: { Accept: 'application/json' },
  });

  if (res.status === 403) {
    throw new Error('Solo administradores pueden acceder a esta información.');
  }

  if (!res.ok) {
    const body = await res.text().catch(() => '');
    throw new Error(`Error ${res.status}: ${body || 'Error al consultar asesores'}`);
  }

  return res.json();
}

/**
 * GET /api/admin/renta-dashboard con filtros
 * @param {{
 *   fecha_inicio: string,
 *   fecha_fin: string,
 *   advisor?: string,
 *   horario_pago?: string,
 *   estado?: string,
 *   abonado_por?: string,
 *   get_all?: boolean
 * }} filters
 * @param {RequestInit} options
 */
export async function getRentaDashboard(filters, options = {}) {
  const query = toQuery(filters);
  const url = `${API_BASE_URL}/api/admin/renta-dashboard?${query}`;

  const res = await fetchWithAuth(url, {
    method: 'GET',
    headers: { Accept: 'application/json', ...(options.headers || {}) },
    ...options,
  });

  if (res.status === 403) {
    throw new Error('Solo administradores pueden ver este dashboard.');
  }
  
  if (res.status === 422) {
    const body = await res.json();
    const error = new Error(body?.message || 'Error de validación');
    error.status = 422;
    error.response = { data: body };
    throw error;
  }

  if (!res.ok) {
    const body = await res.text().catch(() => '');
    throw new Error(`Error ${res.status}: ${body || 'Error al consultar el dashboard de renta'}`);
  }

  return res.json();
}
